export const BASE_PATH = '';
export const DASHBOARD_PATH = '/dashboard';
export const LOGIN_PATH = '/login';
export const FORCE_LOGIN_PATH = '/force-login';
export const LOGOUT_PATH = `${BASE_PATH}${LOGIN_PATH}`;
export const PASSWORD_RECOVERY_PATH = '/forgotpassword';
export const PASSWORD_RESET_PATH = '/resetpassword';
export const REGISTRATION_PATH = '/invitation';
export const USER_REGISTRATION_PATH = '/registration';
export const ACCOUNT_REGISTRATION_PATH = '/account-registration';
export const ACCOUNT_REGISTRATION_CHECK_EMAIL_PATH = '/account-registration/check-email';
export const ACCOUNT_REGISTRATION_CONFIRM_PATH = '/account-registration/:registrationId/confirm';
export const ACCOUNT_REGISTRATION_SET_PASSWORD_PATH = '/account-registration/set-password';
export const EMAIL_ALIAS_CONFIRM_PATH = '/email-alias/:aliasId/confirm';
export const TRANSACTIONS_PATH = '/transactions';
export const TRANSACTION_PATH = '/transaction';
export const ARCHIVE_PATH = '/archives';
export const ARCHIVE_REQUEST_PATH = '/archives/:archiveRequestId';
export const DESIGNER_PATH = '/designer';
export const DESIGN_PATH = '/design';
export const TEMPLATES_PATH = '/templates';
export const TEMPLATE_PATH = '/template';
export const REPORTS_PATH = '/reports';
export const SENDER_REPORT_PATH = '/sender';
export const CEREMONY_PATH = '/ceremony';
export const CEREMONY_DOCUMENT_PATH = 'document';
export const CEREMONY_WELCOME_PATH = 'welcome';
export const CEREMONY_ATTACHMENT_PATH = 'attachment';
export const CEREMONY_F2F_PATH = 'f2f';
export const CEREMONY_SUMMARY_PATH = 'summary';
export const CEREMONY_2FA_PATH = '2fa';
export const CEREMONY_2FA_SMS_PATH = '2fa/sms';
export const CEREMONY_2FA_QNA_PATH = '2fa/qna';
export const CEREMONY_DECLINED_PATH = 'declined';

export const getCeremonyPath = (transactionId) => `${TRANSACTION_PATH}/${transactionId}${CEREMONY_PATH}`;
export const getCeremonySummaryPath = (transactionId) => `${TRANSACTION_PATH}/${transactionId}${CEREMONY_PATH}/${CEREMONY_SUMMARY_PATH}`;
export const getCeremonyDeclinedPath = (transactionId) => `${TRANSACTION_PATH}/${transactionId}${CEREMONY_PATH}/${CEREMONY_DECLINED_PATH}`;
export const ERROR_PATH = '/error';
export const FAST_TRACK_PATH = '/ft';
// admin
export const ADMIN_PATH = '/admin';
export const ADMIN_USER_MANAGEMENT_PATH = 'usermanagement';
export const ADMIN_GROUPS_PATH = 'groups';
export const ADMIN_GROUP_PATH = 'group';
export const ADMIN_SECURITY_PATH = 'security';
export const ADMIN_API_ACCESS_PATH = 'apiaccess';
export const ADMIN_EVENT_NOTIFICATION_PATH = 'eventnotification';
export const ADMIN_BRANDS_PATH = 'brands';
export const ADMIN_DATA_RETENTION_PATH = 'dataretention';
export const ADMIN_CUSTOM_FIELDS_PATH = 'customfields';
export const ADMIN_TRANSACTION_EXPIRY_TIME_PATH = 'transactionexpirytime';
export const ADMIN_SUBSCRIPTION_PATH = 'subscription';
export const ROLES_PATH = 'roles';
// account
export const ACCOUNT_PATH = '/account';
export const ACCOUNT_PERSONAL_INFORMATION_PATH = 'personalinformation';
export const ACCOUNT_EMAIL_ALIASES_PATH = 'emailaliases';
export const ACCOUNT_CHANGE_PASSWORD_PATH = 'password';
export const ACCOUNT_CAPTURE_SIGNATUES_PATH = 'signatures';
export const ACCOUNT_PERSONAL_PREFERENCES_PATH = 'personalpreferences';
export const ACCOUNT_ACCESS_DELEGATION_PATH = 'accessdelegation';
export const ACCOUNT_CUSTOM_FIELDS_PATH = 'customfields';
export const ACCOUNT_GROUPS_PATH = 'groups';
export const ACCOUNT_GROUP_PATH = 'group';
export const ACCOUNT_TWO_FACTOR_AUTH_PATH = '2fa';
export const SELECT_NONE_VALUE = 'none';
export const AI_PATH = '/ai';
export const TEMPLATE_SUGGESTIONS_PATH = '/templatesuggestions';
// oauth
export const OAUTH_PATH = '/oauth';
/** Server route that swaps the session cookie for a Bearer token so the browser can download archives itself. */
export const ARCHIVE_DOWNLOAD_PATH = '/archiveDownload';

export const OAUTH_REFRESH_TOKEN_COOKIE_NAME = 'oauth_refresh_token';
export const OAUTH_ACTOR_DATA_COOKIE_NAME = 'oauth_actor_data';
export const TRUSTED_DEVICE_COOKIE_NAME = 'vs_trusted_device';
export const TRUSTED_DEVICE_TOKEN_FIELD = 'trusted_device_token';
/** Renamed from the csurf default `_csrf` so the partitioned cookie never collides with the unpartitioned one left in browsers. */
export const CSRF_SECRET_COOKIE_NAME = 'csrf_secret';
/** Set only the first time a page loads inside an iframe, so later same-origin XHRs (e.g. token refresh) can still be recognised as embedded even though `Sec-Fetch-Dest` on those requests is `empty`, not `iframe`. */
export const EMBEDDED_SESSION_COOKIE_NAME = 'embedded_session';

// connect (external MCP / app authorization flow)
export const CONNECT_AUTHORIZE_PATH = '/connect/authorize';
export const CONNECT_APPROVE_PATH = '/connect/approve';
export const CONNECT_TOKEN_PATH = '/connect/token';

export const EXCHANGE_ACTOR_HEADERS = {
    EXCHANGE_ACTOR_USER_ID: 'X-Exchange-Actor-User-Id',
    EXCHANGE_ACTOR_USER_IDP_ID: 'X-Exchange-Actor-User-Idp-Id',
    EXCHANGE_REASON: 'X-Exchange-Reason',
    EXCHANGE_TRANSACTION_ID: 'X-Exchange-Transaction-Id',
    SESSION_ACCOUNT_ID: 'X-Session-Account-Id'
};

export const EXCHANGE_ACTOR_CLAIM_FIELDS = [
    'exchange_actor_user_id',
    'exchange_actor_user_idp_id',
    'exchange_reason',
    'transaction_id',
    'session_account_id'
];

// esv
export const ESV_REDIRECT_PATH = '/esv/redirect';

// OAuth token buffer time
export const ACCESS_TOKEN_EXPIRES_BUFFER_SEC = 30;
export const ACCESS_TOKEN_EXPIRES_BUFFER_MS = ACCESS_TOKEN_EXPIRES_BUFFER_SEC * 1000;

export const AUTHENTICATION_PATH = '/authentication';
export const USER_AUTH_PATH = '/authentication/user';
export const RECIPIENT_AUTH_PATH = '/authentication/recipient';
export const SSO_AUTH_PATH = '/authentication/sso';
export const SSO_VERIFIED_PARAM = 'ssoVerified';
export const SENDER_AUTH_PATH = '/auth';

// Group recipient member-token exchange after login
export const EXCHANGE_GROUP_MEMBER_PATH = '/exchange/group-member';

// Error pages
export const UNAUTHORIZED_PATH = '/unauthorized';
export const ACCESS_DENIED_PATH = '/access-denied';
export const KBA_UNAVAILABLE_PATH = '/kba-unavailable';
export const ACCESS_LOCKED_PATH = '/access-locked';
export const SESSION_EXPIRED_PATH = '/session-expired';
export const NOT_FOUND_PATH = '/not-found';

export const DESIGNER_SUB_LINKS = {
    BACK_TO_TRANSACTION: 'backToTransaction',
    BACK_TO_TEMPLATE: 'backToTemplate',
    RECIPIENTS: 'recipients',
    SIGNATURE_FIELDS: 'signatureFields',
    CUSTOM_FIELDS: 'customFields',
    TRANSACTION_SETTINGS: 'transactionSettings',
    TEMPLATE_SETTINGS: 'templateSettings',
    LAYOUTS: 'layouts',
    DOCUMENT_VISIBILITY: 'documentVisibility'
};
